
import {FC} from "react";

import React from 'react';

import SendApprovalForm from "../../forms/ppap/send-approval-form";

interface Interface{
    requestId: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

interface Interface{
    requestId: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

const SendApprovalScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <SendApprovalForm
                    requestId={props.requestId}
                />
            
    );
}
export default SendApprovalScreen;
